import AccordionFAQ from '../components/AccordionFAQ';
import SEO from '../components/SEO';
import { FAQ_ARTICLES, FAQ_SCHEMA_ITEMS } from '../data/faqArticles';
import { ROUTE_META } from '../data/routeMeta';

export default function FaqIndexPage() {
  const meta = ROUTE_META['/faq'];
  const schema = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: FAQ_SCHEMA_ITEMS };

  return (
    <>
      <SEO title={meta.title} description={meta.description} keywords={meta.keywords} canonicalPath="/faq" />
      <section className="space-y-4">
        <h1 className="text-2xl font-bold">VIT GPA & CGPA FAQ</h1>
        <p className="text-sm text-brand-muted">Regulation-focused answers aligned to FFCS Academic Regulations Version 3.2 for VIT GPA, CGPA, attendance, grading, and exam policies.</p>
        <AccordionFAQ items={FAQ_ARTICLES} />
      </section>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </>
  );
}
